import { TechSpaceErrorType } from "./index98.js";
function errorHandler(type, data) {
	let message = "";
	switch (type) {
		case TechSpaceErrorType.Size:
			message = "Technical Space cannot be placed. Size requirements for this space cannot be satisfied with current building layout.";
			break;
		case TechSpaceErrorType.NoSpaceLeft:
			message = "Technical Space cannot be placed. there is no free space left in the current building level.";
			break;
		case TechSpaceErrorType.NoQuantityInfo:
			message = "Technical Space cannot be placed. There is no information provided on the quantity of space instances needed for this space.";
			break;
		case TechSpaceErrorType.NoLevelInfo:
			message = "Technical Space cannot be placed. There is no information provided on the building level this space should be placed.";
			break;
		case TechSpaceErrorType.NotImplementedProperty: {
			const castData = data;
			message = `Technical Space cannot be placed. The property: '${castData.property}: ${castData.value}' has not been implemented yet.`;
			break;
		}
		case TechSpaceErrorType.NoLocationInfo:
			message = "Technical Space cannot be placed. There is no information provided on where this space should be placed relevant to the building.";
			break;
		case TechSpaceErrorType.ZeroQuantityNeeded:
			message = "Technical Space cannot be placed. The quantity needed in the building returns as 0.";
			break;
		default:
			message = "Technical Space cannot be placed. An unknown error has occured.";
			break;
	}
	return {
		type,
		message,
		data
	};
}
export { errorHandler };

//# sourceMappingURL=index101.js.map